<template>
  <div class="w-full" @submit.prevent >
      <template>
          <div  @click="toggleUpload" class="upload_btn_new" :name="fieldName+cid">
              <img class="file-icon" src="@/assets/images/main/file-upload.svg" />
               Upload
          </div>
      </template>
      <template v-if="showFileUpload && false"> 
        <!-- {{ fileUploadShowingText }} -->
          <div class="upload_sec file_upload_popup_sec">
          <div class="category_list">
            <ul>
              <li  :class="{'active':activeTab=='localDrive'}"  @click="changeTab('localDrive')"><span></span>Local Drive</li>
              <li v-if="[48,50,51].indexOf(this.getUserRoleId) <= -1" :class="{'active':activeTab=='docLibrary'}"  @click="changeTab('docLibrary')"><span></span>Documents Library</li>
              <li :class="{'active':activeTab=='gDrive'}"  @click="changeTab('gDrive')"><span></span>Google Drive</li>
              <li :class="{'active':activeTab=='dropBox'}" @click="changeTab('dropBox')"><span></span>Dropbox</li>
              <li :class="{'active':activeTab=='oneDrive'}" @click="changeTab('oneDrive')"><span></span>One Drive</li>
            </ul>
          </div>
          <div class="category_cnt">
              <div v-if="activeTab=='localDrive'" id="local_drive">
                <div class="files_sec">
                  <div class="file_upload"  v-if="true || (fieldName !=null && canRenderField(tplkey,fieldsArray, display,tplsection,fieldName))">
                      <div class="form_group" @click="showFileTypeError = ''">
                        <file-upload  :ref="fieldName+cid"  v-validate="checkFieldIsRequired({'key':tplkey,'section':tplsection, 'fieldsArray':fieldsArray, 'required':required })? 'required': datatype " :hideSelected="true" v-model="fvalue" class="file-upload-input file-upload-input-cs" :name="fieldName+cid"  :data-vv-as="vvas?vvas:placeHolder" :multiple="multiple" :accept="docAcceptType" @input="upload(fvalue)">
                            <img class="file-icon" src="@/assets/images/main/file-upload.svg" />
                            
                            Local Drive
                            <span class="loader" v-if="filesUploading" ><img src="@/assets/images/main/loader.gif"></span>
                        </file-upload>

                      <p v-show="errors.has((formscope!=''?formscope+'.':'')+fieldName+cid)" class="text-danger text-sm-doc">{{ errors.first((formscope!=''?formscope+'.':'')+fieldName+cid) }}</p>
                      <p v-show="showFileTypeError" class="text-danger text-sm-doc">{{ showFileTypeError }}</p>
                  </div>
                  </div>
                </div>
              </div>
              <div v-if="activeTab=='dropBox'" id="dropbox">
                <!-- <span class="connect_btn" @click="openDropboxChooser()">Connect Drop Box</span> -->
              </div> 
              <div v-if="activeTab=='oneDrive'" id="oneDrive">
                <!-- <span class="connect_btn" @click="openOneDrive()">Connect One Drive</span> -->
              </div>
              <div v-if="activeTab=='gDrive'" id="gDrive">
                 <!-- <VueGPicker :docAcceptType="docAcceptType" @emitBlobFiles="emitBlobFiles"></VueGPicker> -->
              </div>
              <div v-if="activeTab=='docLibrary'" id="docLibrary">
                  <!-- <documentLibrary :ref="'documentLibraryRef'" :callFromFileUpload="true" :multiple="multiple" /> -->
              </div>
          </div>
          <ul class="uploaded-list">
              <template v-for="(item, index) in fvalue">
                <template v-if="!checkCurrentUrl">
                  <template v-if="checkProperty(item,'uploadedBy') && checkProperty(getUserData , 'userId')">
                      <template v-if="checkProperty(item,'uploadedBy') == checkProperty(getUserData , 'userId')">
                          <vs-chip v-if="checkProperty(item, 'status') && checkProperty(item, 'path')" @click="item.status=false;remove(index)"  :key="index" :closable="checkProperty(item, 'isNew') == true">
                              <img src="@/assets/images/main/down-arrow2.svg" @click="downloads3file(item)" />
                              {{ item.name }}
                          </vs-chip>
                      </template>
                  </template>
                </template>
                <template v-else>
                  <template v-if="checkProperty(item,'path') && checkProperty(item,'uploadedByRoleId') &&  getUserRoleId == 51 && !showToBeneficiary  ">
                      <template v-if="checkProperty(item,'uploadedByRoleId') == 51">
                          <vs-chip v-if="item.status" @click="item.status=false;remove(index ,checkProperty( item,'resourceId'))"  :key="index" closable>
                              <img src="@/assets/images/main/down-arrow2.svg" @click="downloads3file(item)" />
                              {{ item.name }}
                          </vs-chip>
                      </template>
                  </template>
                  <template v-else>
                      <vs-chip v-if="checkProperty(item,'path') && item.status" @click="item.status=false;remove(index,checkProperty( item,'resourceId'))"  :key="index" closable>
                          <img src="@/assets/images/main/down-arrow2.svg" @click="downloads3file(item)" />
                          {{ item.name }} 
                      </vs-chip>
                  </template>
                </template>
              </template>
          </ul>
          <div class="popup-footer relative" >
            <span class="loader" v-if="filesUploading"  ><img src="@/assets/images/main/loader.gif"/></span>
          <vs-button  color="dark"  class="cancel" :disabled="filesUploading" @click="updateData();showFileUpload=false" type="filled"  >Close</vs-button>
          <vs-button  color="success"  class="save" :disabled="filesUploading" @click="updateData(true)" type="filled" > Submit  </vs-button>
          </div>
        </div>
      </template>

  <vs-popup class="Change_petition_wrap file-up-modal drivemodal cls-btn" v-if="showFileUpload" v-bind:title="'Choose Documents'" :active.sync="showFileUpload">
        <div class="upload_sec upload_secv2">
          <div class="category_list">
            <!-- <ul>
              <li  :class="{'active':activeTab=='localDrive'}"  @click="changeTab('localDrive')"><span></span>Local Drive</li>
              <li v-if="[50,51].indexOf(this.getUserRoleId) <= -1" :class="{'active':activeTab=='docLibrary'}"  @click="changeTab('docLibrary')"><span></span>Documents Library</li>
              <li :class="{'active':activeTab=='gDrive'}"  @click="changeTab('gDrive')"><span></span>Google Drive</li>
              <li :class="{'active':activeTab=='dropBox'}" @click="changeTab('dropBox')"><span></span>Dropbox</li>
              <li :class="{'active':activeTab=='oneDrive'}" @click="changeTab('oneDrive')"><span></span>One Drive</li>
            </ul> -->
            <ul class="drive-list">
              <li>
                <!-- <span></span>Local Drive -->
              
                   <file-upload  :ref="fieldName+cid"   :hideSelected="true" v-model="fvalue" class="file-upload-input file-upload-input-cs" :name="fieldName+cid"  :data-vv-as="vvas?vvas:placeHolder" :multiple="multiple" :accept="docAcceptType" @input="upload(fvalue)">
                      <figure><img  src="@/assets/images/storage-device.png" /></figure> 
                      Local Drive 
                  </file-upload>
              
              </li>
              <li v-if="[48,50,51].indexOf(this.getUserRoleId) <= -1 && !callFromDocuments"  @click="changeTab('docLibrary')">
              <figure><img class="file-icon" src="@/assets/images/document.png" /></figure>
                Documents Library</li>
              <li >
                <figure @click="changeTab('gDrive')"><img class="file-icon" src="@/assets/images/google-drive.png" /></figure>
                Google Drive
                <label class="primary-btn gdrive-disconnect" v-if="gDriveOauthToken !=null && gDriveOauthToken != ''"  @click="cleargdriveAccessToken()">
                  Disconnect
                </label>
                <!-- v-if="gDriveOauthToken !=null && gDriveOauthToken != ''" -->
              </li>
              <li @click="changeTab('dropBox')">
                <figure><img class="file-icon" src="@/assets/images/dropbox.png" /></figure>
                Dropbox</li>
              <li @click="changeTab('oneDrive')">
              <figure><img class="file-icon" src="@/assets/images/oneDrive.svg" /></figure>
                OneDrive</li>
            </ul>
          </div>
          <div class="category_cnt d-none">
              <div v-if="activeTab=='localDrive'" id="local_drive">
                <div class="files_sec">
                  <div class="file_upload"  v-if="true || (fieldName !=null && canRenderField(tplkey,fieldsArray, display,tplsection,fieldName))">
                      <div class="form_group" @click="showFileTypeError = ''">
                        <!-- <file-upload  :ref="fieldName+cid"  v-validate="checkFieldIsRequired({'key':tplkey,'section':tplsection, 'fieldsArray':fieldsArray, 'required':required })? 'required': datatype " :hideSelected="true" v-model="fvalue" class="file-upload-input file-upload-input-cs" :name="fieldName+cid"  :data-vv-as="vvas?vvas:placeHolder" :multiple="multiple" :accept="docAcceptType" @input="upload(fvalue)">
                            <img class="file-icon" src="@/assets/images/main/file-upload.svg" />
                            
                            Local Drive
                            <span class="loader" v-if="filesUploading" ><img src="@/assets/images/main/loader.gif"></span>
                        </file-upload> -->

                      <p v-show="errors.has((formscope!=''?formscope+'.':'')+fieldName+cid)" class="text-danger text-sm-doc">{{ errors.first((formscope!=''?formscope+'.':'')+fieldName+cid) }}</p>
                      <p v-show="showFileTypeError" class="text-danger text-sm-doc">{{ showFileTypeError }}</p>
                  </div>
                  </div>
                </div>
              </div>
              <div v-if="activeTab=='dropBox'" id="dropbox">
                <!-- <span class="connect_btn" @click="openDropboxChooser()">Connect Drop Box</span> -->
              </div> 
              <div v-if="activeTab=='oneDrive'" id="oneDrive">
                <!-- <span class="connect_btn" @click="openOneDrive()">Connect One Drive</span> -->
              </div>
              <div v-if="activeTab=='gDrive'" id="gDrive">
                 <!-- <VueGPicker :docAcceptType="docAcceptType" @emitBlobFiles="emitBlobFiles"></VueGPicker> -->
              </div>
              <!-- <div v-if="[50,51].indexOf(this.getUserRoleId) <= -1" id="docLibrary">
                  <documentLibrary :ref="'documentLibraryRef'" :callFromFileUpload="true" :multiple="multiple" />
              </div> -->
          </div>
          <ul class="uploaded-list">
              <template v-for="(item, index) in fvalue">
                <template v-if="!checkCurrentUrl">
                  <template v-if="(checkProperty(item,'uploadedBy') && checkProperty(getUserData , 'userId')) || (routePath ==='i9/fill-verifier-info')">
                      <template v-if="(checkProperty(item,'uploadedBy') == checkProperty(getUserData , 'userId')) || (routePath==='i9/fill-verifier-info')">
                          <vs-chip v-if="checkProperty(item, 'status') && checkProperty(item, 'path')" @click="item.status=false;remove(index)"  :key="index" :closable="checkProperty(item, 'isNew') == true">
                              <img src="@/assets/images/main/down-arrow2.svg" @click="downloads3file(item)" />
                              {{ item.name }}
                          </vs-chip>
                      </template>
                  </template>
                </template>
                <template v-else>
                  <template v-if="checkProperty(item,'path') && checkProperty(item,'uploadedByRoleId') &&  getUserRoleId == 51 && !showToBeneficiary  ">
                      <template v-if="checkProperty(item,'uploadedByRoleId') == 51">
                          <vs-chip v-if="item.status" @click="item.status=false;remove(index ,checkProperty( item,'resourceId'))"  :key="index" closable>
                              <img src="@/assets/images/main/down-arrow2.svg" @click="downloads3file(item)" />
                              {{ item.name }}
                          </vs-chip>
                      </template>
                  </template>
                  <template v-else>
                      <vs-chip v-if="getUserRoleId != 51 && checkProperty(item,'path') && item.status" @click="item.status=false;remove(index,checkProperty( item,'resourceId'))"  :key="index" closable>
                          <img src="@/assets/images/main/down-arrow2.svg" @click="downloads3file(item)" />
                          {{ item.name }} 
                      </vs-chip>
                  </template>
                </template>
              </template>
          </ul>
          <div class="popup-footer relative" >
            <span class="loader" v-if="(filesUploading|| !checkFilesUploadCompleted)"  ><img src="@/assets/images/main/loader.gif"/></span>
          <vs-button  color="dark"  class="cancel footer_action" :disabled="filesUploading" @click="updateData();showFileUpload=false" type="filled"  >Close</vs-button>
          <!-- <vs-button  color="success"  class="save footer_action" :disabled="(filesUploading|| !checkFilesUploadCompleted)" @click="updateData(true)" type="filled" > Submit  </vs-button> -->
          <vs-button  color="success"  class="save footer_action" :disabled="(filesUploading|| !checkFilesUploadCompleted)?(filesUploading|| !checkFilesUploadCompleted):fvalue.length==0?true:false" @click="updateData(true)" type="filled" > Submit  </vs-button>
          </div>
        </div>
    <!-- <div class="actions_footer">
      <button @click="deleteAllConform = false" class="btn cancel">No</button>
      <button class="btn" @click="action_onnotification('removeAll')">
        Yes
      </button>
    </div> -->
  </vs-popup>
  <vs-popup  v-if="[48,50,51].indexOf(this.getUserRoleId) <= -1 && !callFromDocuments && showDocumentLibrary" class="Change_petition_wrap docfiles-modal cls-btn" v-bind:title="'Documents Library'" :active.sync="showDocumentLibrary">
    <div class="upload_sec upload_secv2">
      <div class="category_cnt">
        <div>
          <documentLibrary :ref="'documentLibraryRef'" :callFromFileUpload="true" :multiple="multiple" />
        </div>
      </div>
    </div>
    <div class="popup-footer relative">
      <button @click="hideMe()" class="cancel footer_action">Cancel</button>
      <button class="save footer_action" @click="submitForm()">
        Yes
      </button>
    </div>
  </vs-popup>
  </div>
</template>
<script>
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import FileUpload from "vue-upload-component/src";
import documentLibrary from "@/views/documents/documentsList.vue"
import JQuery from "jquery";
import mime from 'mimetype';
import { gapi } from "gapi-script";
import VueGPicker from './googledrive.vue'
// /documents import { Picker, MSALAuthenticate, LogNotifications, IFilePickerOptions,  IPicker, Popup, } from "onedrive-picker-file";


export default {
data: () => ({
  windowOpeningUrl:'',
  checkParentInterval:null,
  routePath:'',
  showDocumentLibrary:false,
    //Google Drive 
    pickerLoaded:false,
      oauthDriveToken:'',
      gDriveFilesAndFolders: [],
      attachments: [],
      pickerApiLoaded: false,
      developerKey: "AIzaSyAO10Ob_xLcXPI_vP1NxKbPSer4u3Lc9D0",
      clientId: "34479281417-9h58pod2rqm2iuketsgschef1ugs7ga7.apps.googleusercontent.com",
      scope: "https://www.googleapis.com/auth/drive.file",
      gDriveOauthToken: null,
      gDriveFilesLoading:false,
      gDriveBredCrumbs:[],
      configDetails:null,
  /////////////////////
    settings: {
        wheelSpeed: 0.6,
    },
    showFileUpload:false,
    activeTab:'localDrive',
    filesUploading:false,
    showFileTypeError:'',
    fvalue: [],
    docAcceptType: "image/png,image/jpeg,image/jpg, image/*, application/pdf, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document",
}),
components:{
  VueGPicker,
    VuePerfectScrollbar,
    FileUpload,
    documentLibrary
    // Picker, MSALAuthenticate, LogNotifications, IFilePickerOptions,  IPicker, Popup
},
methods:{
  getRoutePath() {
    this.routePath = '';
    setTimeout(() => {
      this.routePath = this.$router.currentRoute.name
    }, 100);

  },
  cleargdriveAccessToken(){
    let path ="/oauth/save-access-token";
    let postData = {
      config:{
        googleDrive:{
          'clientSecret':null
        }
      }
    };
    this.$store.dispatch("commonAction" ,{data:postData,path:path})
      .then(res => {
        this.gDriveOauthToken = null;
        this.handleAuthClick();
      }).catch((err)=>{

      })
  },
  submitForm(){
    this.updateLibraryDocumets(true);
  },
  async createPicker() {
      var $self = this;
 const view = new google.picker.View(google.picker.ViewId.DOCS);
  view.setMimeTypes();
    const picker = new google.picker.PickerBuilder()
      .enableFeature(google.picker.Feature.NAV_HIDDEN)
      .enableFeature(google.picker.Feature.MULTISELECT_ENABLED)
      .setDeveloperKey(API_KEY)
      .setAppId(APP_ID)
      .setOAuthToken($self.gDriveOauthToken)
      .addView(view)
      .addView(new google.picker.DocsUploadView())
      .setCallback($self.pickerCallback)
      .build();
      picker.setVisible(true);
  },
  async pickerCallback(data) {
    let self = this;
    //self.filesUploading = true;
    let access_Token = this.gDriveOauthToken;
    let blobFiles = [];
    if (data.action === google.picker.Action.PICKED) {
       const $ = JQuery;
      $('body').removeClass('gdriveopen');
      if(data && data['docs'] && data['docs'].length>0){
        let googleDriveFiles = _.cloneDeep(data['docs']);
        self.filesUploading = true;
        _.forEach(googleDriveFiles, (obj)=>{
          if((_.has(obj, 'link') && obj['link']) || true){
            let downloadUrl = `https://www.googleapis.com/drive/v3/files/${obj['id']}?alt=media`;
            fetch(downloadUrl,{
              method: 'GET',
              headers: {
                'Authorization': 'Bearer ' + access_Token,
              },
            })
            .then(response => {
              return response.blob(); // Convert the response to a Blob
            })
            .then(blob => {
              console.log(blob);
              let item = {};
              if(_.has(obj, 'name') && obj['name']){
                item['name'] = obj['name']; 
                let mimetype = mime.lookup(obj.name);
                if(mimetype){
                  item.mimetype =mimetype;
                }
              }
              item['file'] = blob;
              item['path'] = '';
              item['isNew'] = true;
              item['status'] = true;
              item['uploadedBy']= self.checkProperty(self.getUserData,'userId')!=''?self.checkProperty(self.getUserData,'userId'):null
              item['uploadedByName']= self.checkProperty(self.getUserData,'name')!=''?self.checkProperty(self.getUserData,'name'):''
              item['uploadedByRoleId'] = self.getUserRoleId?self.getUserRoleId:null
              item['uploadedByRoleName'] = self.checkProperty(self.getUserData,'loginRoleName')
              blobFiles.push(item)
              if(data['docs'] && blobFiles &&  (data['docs'].length == blobFiles.length)){
                // console.log(JSON.stringify(blobFiles));
                // this.$emit('emitBlobFiles', blobFiles )
                self.uploadBloBObject(blobFiles)
              }
            })
            .catch(error => {
              console.error('Error:', error);
            });
          }
        })
      }
      
    }
    if(data.action === 'cancel'){
      self.filesUploading = false;
       const $ = JQuery;
      $('body').removeClass('gdriveopen');
    }
  },
  handleAuthClick() {
    if(this.gDriveOauthToken && this.gDriveOauthToken != null){
      window.open(this.windowOpeningUrl+"/google-drive-check?token="+this.gDriveOauthToken+"&location="+window.location.origin, "mozillaWindow", "popup");
       //window.open("http://localhost:8081/google-drive-check?token="+this.gDriveOauthToken+"&location="+window.location.origin, "mozillaWindow", "popup");
      window.addEventListener('message', this.receiveMessage);
    }else{
      window.open(this.windowOpeningUrl+"/google-drive-check?location="+window.location.origin, "mozillaWindow", "popup");
      //window.open("http://localhost:8081/google-drive-check?location="+window.location.origin, "mozillaWindow", "popup");
      window.addEventListener('message', this.receiveMessage);
    }
  },
  receiveBlobFiles(docs){
    let self = this;
    let blobFiles = [];
    let googleDriveFiles = _.cloneDeep(docs);
    let access_Token = this.gDriveOauthToken;
       self.filesUploading = true;
        _.forEach(googleDriveFiles, (obj)=>{
          console.log(obj)
          if((_.has(obj, 'link') && obj['link']) || true){
            let downloadUrl = `https://www.googleapis.com/drive/v3/files/${obj['id']}?alt=media`;
            fetch(downloadUrl,{
              method: 'GET',
              headers: {
                'Authorization': 'Bearer ' + access_Token,
              },
            })
            .then(response => {
              return response.blob(); // Convert the response to a Blob
            })
            .then(blob => {
              let item = {};
              if(_.has(obj, 'name') && obj['name']){
                item['name'] = obj['name']; 
                let mimetype = mime.lookup(obj.name);
                if(mimetype){
                  item.mimetype =mimetype;
                }
              }
              item['file'] = blob;
              item['path'] = '';
              item['isNew'] = true;
              item['status'] = true;
              item['uploadedBy']= self.checkProperty(self.getUserData,'userId')!=''?self.checkProperty(self.getUserData,'userId'):null
              item['uploadedByName']= self.checkProperty(self.getUserData,'name')!=''?self.checkProperty(self.getUserData,'name'):''
              item['uploadedByRoleId'] = self.getUserRoleId?self.getUserRoleId:null
              item['uploadedByRoleName'] = self.checkProperty(self.getUserData,'loginRoleName')
              blobFiles.push(item)
              if(googleDriveFiles && blobFiles &&  (googleDriveFiles.length == blobFiles.length)){
                // console.log(JSON.stringify(blobFiles));
                // this.$emit('emitBlobFiles', blobFiles )
                self.uploadBloBObject(blobFiles);
              }
            })
            .catch(error => {
              console.error('Error:', error);
            });
          }
        })
  },
  receiveMessage(event) {
    console.log(event);
    console.log('receiveMessage')
    // Check the origin to ensure it's from the child window
    if (event.origin == window.location.origin /* replace with your child window origin */) {
      if(event && event.data && event['data']['token'] ){
        this.gDriveOauthToken = event['data']['token'];
        this.saveGoogleDriveAccessToken(this.gDriveOauthToken)
      }
      if(event && event.data && event['data']['googleDriveFiles'] && this.checkProperty(event['data']['googleDriveFiles'], 'length') >0 ){
        let docs = event['data']['googleDriveFiles']
        this.receiveBlobFiles(docs)
      }
      window.removeEventListener('message', this.receiveMessage);
    }
  },
  saveGoogleDriveAccessToken(response){
    let path ="/oauth/save-access-token";
    let postData = {
      config:{
        googleDrive:{
          'clientSecret':response
        }
      }
    };
    this.$store.dispatch("commonAction" ,{data:postData,path:path})
      .then(res => {
        // console.log(JSON.stringify(res))
        //  this.gDriveOauthToken = response.access_token;
        // this.createPicker();   
      }).catch((err)=>{})
  },
  getGoogleDriveAccessToken(){
    let payLoad= {} 
    let path = '/oauth/get-access-token' 
    this.$store.dispatch('commonAction',{'data':payLoad, 'path':path}).then((response)=>{
      if(this.checkProperty(response, 'config') && this.checkProperty(response, 'config', 'googleDrive')  && this.checkProperty(response['config'], 'googleDrive', 'clientSecret') ){
        this.gDriveOauthToken = this.checkProperty(response['config'], 'googleDrive', 'clientSecret');
      }
    }).catch((err)=>{

    })
  },


  openOneDrive(){
    let self = this;
    var  OneDriveOpenOptions = {
          clientId: 'fb8b32d1-7139-43c4-915f-714055f560e7',
          action: "download",
          multiSelect: true,
          openInNewWindow: true,
          advanced: {
            redirectUri: window.location.origin,
          },
          success: function (files) {
            if(files){
              self.filesUploading = true;
              let access_Token = files['accessToken'];
              let blobFiles = [];
              if(files['value'] &&  files['value'].length>0){
                let oneDriveFiles = _.cloneDeep(files['value'])
                _.forEach(oneDriveFiles, (obj)=>{
                  if((_.has(obj, 'link') && obj['link']) || true){
                    let downloadUrl = `https://graph.microsoft.com/v1.0/me/drive/items/${obj['id']}/content`;
                    fetch(downloadUrl,{
                      method: 'GET',
                      headers: {
                        'Authorization': 'Bearer ' + access_Token,
                      },
                    })
                    .then(response => {
                      if (!response.ok) {
                        throw new Error('Network response was not ok');
                      }
                      return response.blob(); // Convert the response to a Blob
                    })
                    .then(blob => {
                      console.log(blob);
                      let item = {};
                      if(_.has(obj, 'name') && obj['name']){
                          item['name'] = obj['name']; 
                          let mimetype = mime.lookup(obj.name);
                          if(mimetype){
                              item.mimetype =mimetype;
                          }
                      }
                      item['file'] = blob;
                      item['path'] = '';
                      item['isNew'] = true;
                      item['status'] = true;
                      item['uploadedBy']= self.checkProperty(self.getUserData,'userId')!=''?self.checkProperty(self.getUserData,'userId'):null
                      item['uploadedByName']= self.checkProperty(self.getUserData,'name')!=''?self.checkProperty(self.getUserData,'name'):''
                      item['uploadedByRoleId'] = self.getUserRoleId?self.getUserRoleId:null
                      item['uploadedByRoleName'] = self.checkProperty(self.getUserData,'loginRoleName')
                      blobFiles.push(item)
                      if(files['value'] && blobFiles &&  (files['value'].length == blobFiles.length)){
                          self.uploadBloBObject(blobFiles)
                      }
                      // Use the Blob object as needed
                      // For example, you can create a URL for the Blob and display it in your application
                      // const blobUrl = URL.createObjectURL(blob);
                      // console.log('Blob URL:', blobUrl);

                      // You can now use the blob for various purposes, such as displaying it in your application or uploading it to another service.
                    })
                    .catch(error => {
                      console.error('Error:', error);
                    });
                  }
                })
              }
              
            }
          },
          cancel: function () { 
          },
          error: function (e) { reject(e); }
    };
    OneDrive.open(OneDriveOpenOptions);
  },
  openDropboxChooser() {
    let self = this;
    const options = {
      // Required. Called when a user selects an item in the Chooser.
      success: function(files) {
          this.filesUploading = false;
          let blobFiles = [];
        if(files && files.length > 0){
          self.filesUploading = true;
          _.forEach(files, (obj)=>{
            if(_.has(obj, 'link') && obj['link']){
              fetch(obj['link']) .then(function (response) {
                  return response.blob();
              })
              .then(function (blob) {
                  let item = {};
                  if(_.has(obj, 'name') && obj['name']){
                      item['name'] = obj['name']; 
                      let mimetype = mime.lookup(obj.name);
                      if(mimetype){
                          item.mimetype =mimetype;
                      }
                  }
                  item['file'] = blob;
                  item['path'] = '';
                  item['isNew'] = true;
                  item['status'] = true;
                  item['uploadedBy']= self.checkProperty(self.getUserData,'userId')!=''?self.checkProperty(self.getUserData,'userId'):null
                  item['uploadedByName']= self.checkProperty(self.getUserData,'name')!=''?self.checkProperty(self.getUserData,'name'):''
                  item['uploadedByRoleId'] = self.getUserRoleId?self.getUserRoleId:null
                  item['uploadedByRoleName'] = self.checkProperty(self.getUserData,'loginRoleName')
                  blobFiles.push(item)
                  if(files && blobFiles &&  (files.length == blobFiles.length)){
                      self.uploadBloBObject(blobFiles)
                  }
              })
              .catch(function (error) {
                  self.filesUploading = false;
                  console.error('Error fetching file:', error);
              });
            }
          })
        }
      },
      // Optional. Called when the user closes the dialog without selecting a file
      // and does not include any parameters.
      cancel: function() {
      },
      // Optional. "preview" (default) is a preview link to the document for sharing,
      // "direct" is an expiring link to download the contents of the file. For more
      // information about link types, see Link types below.
      linkType: "direct", // or "direct" preview

      // Optional. A value of false (default) limits selection to a single file, while
      // true enables multiple file selection.
      multiselect: self.multiple, // or true

      // Optional. This is a list of file extensions. If specified, the user will
      // only be able to select files with these extensions. You may also specify
      // file types, such as "video" or "images" in the list. For more information,
      // see File types below. By default, all extensions are allowed.
      extensions: ['.pdf', '.doc', '.docx'],

      // Optional. A value of false (default) limits selection to files,
      // while true allows the user to select both folders and files.
      // You cannot specify `linkType: "direct"` when using `folderselect: true`.
      folderselect: false, // or true

      // Optional. A limit on the size of each file that may be selected, in bytes.
      // If specified, the user will only be able to select files with size
      // less than or equal to this limit.
      // For the purposes of this option, folders have size zero.
      sizeLimit: 999999, // or any positive number
    };
    Dropbox.choose(options);
  },
  getBlobFromDropbox(item, fileOb){
      let fileObj = fileOb
    let self = this;
    fetch(item)
      .then(function (response) {
          return response.blob();
      })
      .then(function (blob) {
        self.uploadBloBObject(blob, fileObj)
      })
      .catch(function (error) {
          console.error('Error fetching file:', error);
      });
  },
  uploadBloBObject(files){
      let self = this;
      let uploadedFiles = [];
      let maper = files;
      let count =0;
      if(maper && maper.length>0){
          this.filesUploading = true;
          _.forEach(maper, (item)=>{
              let formData = new FormData();
              formData.append("files", item['file']);
              formData.append("secureType", "private");
              formData.append("getDetails", true);
              self.$store.dispatch("uploadS3File", formData).then((response) => {
                  if(_.has(response, 'data') && _.has(response['data'], 'result') && response['data']['result']){
                      response.data.result.forEach((urlGenerated) => {
                          delete item.file;
                          if(_.has(urlGenerated ,'path' )){
                              item['path'] = urlGenerated['path'];
                          }
                          if(_.has(urlGenerated ,'size' )){
                              item['size'] = urlGenerated['size'];
                          }
                          if(_.has(urlGenerated ,'extn' )){
                              item['extn'] = urlGenerated['extn'];
                          }
                      })
                      self.fvalue.push(item);
                     // uploadedFiles.push(item);
                      count =count+1;
                      if(maper.length >=count ){
                          self.filesUploading =false;     
                          //this.updateData();                        
                      }
                  }
              }).catch((err)=>{
                  count =count+1;
                  if(maper.length >=count ){
                      self.filesUploading =false;     
                  }
              })
          })
      }
  },
  init(){
    if(this.value){
      this.fvalue = _.cloneDeep(this.value);
    }
    if(this.checkProperty(this.fvalue, 'length')>0){
      _.forEach(this.fvalue, (doc)=>{
          if(!_.has(doc, 'status')){
              doc['status'] = true;
          }
      })
    }
    this.fvalue = _.cloneDeep(this.fvalue)
  },
  toggleUpload(){
    this.showFileUpload = !this.showFileUpload;
    if(this.showFileUpload){
      this.init();
      this.getGoogleDriveAccessToken();
    }
    window.removeEventListener('message', this.receiveMessage);
  },
  openDocLibrary(){
    this.$modal.show('documentLibraryPopupModal');
    setTimeout(()=>{
      // let selectedDocs = this.$store.state.selectedDocumentList;
      // if(selectedDocs && selectedDocs.length>0 && [50,51].indexOf(this.getUserRoleId)<=-1){
      //   this.$refs['documentLibraryRef'].deselectDocsList();
      // }
      this.$store.commit('updateSelectedDocuments',[]);
    })
  },
  changeTab(tab, callFromMount=false){
    this.activeTab = tab;
    if([48,50,51].indexOf(this.getUserRoleId)<=-1 && !callFromMount){
      this.updateLibraryDocumets()
    }
    if(tab =='dropBox' ){
      this.openDropboxChooser();
    }
    if(tab =='docLibrary' ){
      setTimeout(()=>{
        this.showFileUpload = false;
      })
      //this.showFileUpload = false; 
      setTimeout(()=>{
        this.showDocumentLibrary = true;
      })
    }
    if(tab =='oneDrive' ){
      this.openOneDrive();
    }
    if(tab =='gDrive' ){
      // this.checkParentInterval = setInterval(() => {
      //   if (window.opener.closed) {
      //     console.log('Parent window is closed');
      //     clearInterval(this.checkParentInterval);
      //   }
      // }, 1000);
      // const $ = JQuery;
      // $('body').addClass('gdriveopen');
      this.getGoogleDriveAccessToken();
      this.handleAuthClick();
    }
    if(tab != 'gDrive' ){
      const $ = JQuery;
      $('body').removeClass('gdriveopen');
    }
    if(callFromMount){
      setTimeout(()=>{
          this.init();
      })
    }
  },
  hideMe(){
    this.$store.commit('updateSelectedDocuments',[]);
    if([48,50,51].indexOf(this.getUserRoleId)<=-1){
      this.$refs['documentLibraryRef'].deselectDocsList();
    }
    setTimeout(()=>{
      this.showDocumentLibrary = false;
    })
    setTimeout(()=>{
      this.showFileUpload = true;
    })
    
  },
  updateLibraryDocumets(callFromSubmit = false){
    let selectedDocs = this.$store.state.selectedDocumentList;
   let self = this;
    if(selectedDocs && selectedDocs.length>0){
      _.forEach(selectedDocs, (item)=>{
          if(_.has(item, 'path') && item['path'] ){
              if(_.has(item, 'status') && item['status']){
                  let findobj = _.find(this.fvalue,{path:item['path']});
                  if(!findobj){
                    let  tempitem = {
                      extn:item.extn?item.extn:'',
                      resourceId:item.resourceId?item.resourceId:'',
                      name: item.name,
                      removeFile:item.removeFile ? item.removeFile : false,
                      size:item.size ? item.size : null,
                      file: item.file ? item.file : null,
                      path: item.path ? item.path : "",
                      isNew: true,
                      status: item.status === false || item.status === true ? item.status : true,
                      mimetype: item.mimetype ? item.mimetype : '',
                      uploadedBy:item.uploadedBy?item.uploadedBy:self.checkProperty(self.getUserData,'userId')!=''?self.checkProperty(self.getUserData,'userId'):null,
                      uploadedByName:item.uploadedByName?item.uploadedByName:self.checkProperty(self.getUserData,'name')!=''?self.checkProperty(self.getUserData,'name'):'',
                      uploadedByRoleId:item.uploadedByRoleId?item.uploadedByRoleId:self.getUserRoleId?self.getUserRoleId:null,
                      uploadedByRoleName:item.uploadedByRoleName?item.uploadedByRoleName:self.checkProperty(self.getUserData,'loginRoleName'),
                      fileUploading: item.path ? false : true,
                    }
                    //item['isNew'] = true;
                    this.fvalue.push(tempitem)
                  }
              }
              if(!_.has(item, 'status')){
                  let findobj = _.find(this.fvalue,{path:item['path']});
                  if(!findobj){
                    let  tempitem = {
                      extn:item.extn?item.extn:'',
                      resourceId:item.resourceId?item.resourceId:'',
                      name: item.name,
                      removeFile:item.removeFile ? item.removeFile : false,
                      size:item.size ? item.size : null,
                      file: item.file ? item.file : null,
                      path: item.path ? item.path : "",
                      isNew: true,
                      status: true,
                      mimetype: item.mimetype ? item.mimetype : '',
                      uploadedBy:item.uploadedBy?item.uploadedBy:self.checkProperty(self.getUserData,'userId')!=''?self.checkProperty(self.getUserData,'userId'):null,
                      uploadedByName:item.uploadedByName?item.uploadedByName:self.checkProperty(self.getUserData,'name')!=''?self.checkProperty(self.getUserData,'name'):'',
                      uploadedByRoleId:item.uploadedByRoleId?item.uploadedByRoleId:self.getUserRoleId?self.getUserRoleId:null,
                      uploadedByRoleName:item.uploadedByRoleName?item.uploadedByRoleName:self.checkProperty(self.getUserData,'loginRoleName'),
                      fileUploading: item.path ? false : true,
                    }
                      // item['isNew'] = true;
                      // item['status'] = true;
                      this.fvalue.push(tempitem)
                  }
              }
              // if(!_.has(item, 'status') ||(_.has(item, 'status') && !item['status'])){
              //     let findobj = _.find(this.fvalue,{path:item['path']});
              //     if(!findobj){
              //         //item['isNew'] = true;
              //         item['status'] = true;
              //         this.fvalue.push(item)
              //     }
              // }
              
          }
      })
      if(callFromSubmit){
        this.$store.commit('updateSelectedDocuments',[]);
        if(selectedDocs && selectedDocs.length>0 && [48,50,51].indexOf(this.getUserRoleId)<=-1){
          this.$refs['documentLibraryRef'].deselectDocsList();
        }
      }
    }
    setTimeout(()=>{
      this.showDocumentLibrary = false;
    })
    setTimeout(()=>{
      this.showFileUpload = true;
    })
  },
  updateData(callFromSubmit = false) {
    let submitCall = callFromSubmit
    let acceptTypes = this.docAcceptType; 
    let toasterMessage = ''
    if(acceptTypes == 'application/pdf'){
      toasterMessage = 'Select pdf documents only'
    }
    if(acceptTypes == 'application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document'){
      toasterMessage = 'Select Word documents only'
    }
    if(acceptTypes == '.jpg,.jpeg,.png'){
      toasterMessage = 'Select Image only'
    }
    if(this.multiple == false){
        if(callFromSubmit){
            let selectedDocs = this.$store.state.selectedDocumentList;
            if(selectedDocs && selectedDocs.length>0 && [48,50,51].indexOf(this.getUserRoleId)<=-1){
                _.forEach(selectedDocs, (item)=>{
                    if(_.has(item, 'path') && item['path'] ){
                        if(_.has(item, 'status') && item['status']){
                            let findobj = _.find(this.fvalue,{path:item['path']});
                            if(!findobj){
                                item['isNew'] = true;
                                this.fvalue.push(item)
                            }
                        }
                        if(!_.has(item, 'status') ){
                            let findobj = _.find(this.fvalue,{path:item['path']});
                            if(!findobj){
                                item['isNew'] = true;
                                item['status'] = true;
                                this.fvalue.push(item)
                            }
                        }
                    
                    }
                })
            }
            this.$store.commit('updateSelectedDocuments',[]);
        }
        if(this.checkProperty(this.fvalue, 'length')>1){
          this.fvalue = [];
          this.showToster({ message: 'Select One File', isError: true });
          this.$store.commit('updateSelectedDocuments',[]);
          if(selectedDocs && selectedDocs.length>0 && [48,50,51].indexOf(this.getUserRoleId)<=-1){
            this.$refs['documentLibraryRef'].deselectDocsList();
          }
        }else{
            if(this.checkProperty(this.fvalue, 'length') == 1){
                _.forEach(this.fvalue, (item)=>{
                    if(!_.has(item, 'userType') && this.userType !='' && this.userType ){
                        item['userType'] = this.userType
                    }
                    if(!_.has(item, 'typeId') && this.typeId !=null && this.typeId ){
                        item['typeId'] = this.typeId
                    }
                    if(!_.has(item, 'childrenId') && this.childrenId !='' && this.childrenId){
                        item['childrenId'] = this.childrenId
                    }
                    if(!_.has(item, 'userName') && this.userName !='' && this.userName){
                        item['userName'] = this.userName
                    }
                })
            }
            if(this.docAcceptType){
              // (mimetype.includes('image/')
              let filterdAcceptList = [];
              filterdAcceptList = _.filter(this.fvalue, (item)=>{
                if(_.has(item, 'mimetype') && acceptTypes.includes(item['mimetype']) ){
                  return item;
                }
              })
              if(filterdAcceptList && filterdAcceptList.length == 0 && acceptTypes && toasterMessage ){
                //this.showToster({ message: toasterMessage, isError: true });
                if(submitCall){
                  this.showToster({ message: toasterMessage, isError: true });
                }
                this.fvalue = [];
              }else{
                if(callFromSubmit){
                  if(this.maxData){
                    let list = [];
                    if(list){
                      list = _.filter(filterdAcceptList, (dItem)=>{
                        if(dItem['size'] <= 12582912 ){
                          return dItem
                        }
                      });
                      if(list.length>0){
                        this.fvalue = _.cloneDeep(list)
                        this.$emit('input', this.fvalue)
                        this.$emit('updateData', this.fvalue, this.emitCategory, this.emitSubCategory);
                        setTimeout(()=>{
                            this.showFileUpload = false;
                        }) 
                      }else{
                        this.fvalue = [];
                        this.showToster({ message: 'The File size to be less than 12 MB.', isError: true });
                      }
                    }
                  }else{
                    this.fvalue = _.cloneDeep(filterdAcceptList);
                    this.$emit('input', this.fvalue)
                    this.$emit('updateData', this.fvalue, this.emitCategory, this.emitSubCategory);
                    setTimeout(()=>{
                      this.fvalue = [];
                        this.showFileUpload = false;
                    }) 
                  }
                }else{
                  if(this.value && this.value.length>0){
                    this.fvalue = _.cloneDeep(filterdAcceptList);
                    this.$emit('input', this.fvalue)
                    this.$emit('updateData', this.fvalue, this.emitCategory, this.emitSubCategory);           
                    setTimeout(()=>{
                      this.fvalue = [];
                      this.showFileUpload = false;
                    })
                  }else{
                    this.$emit('input', []);
                    this.fvalue = [];
                    this.$emit('updateData', [], this.emitCategory, this.emitSubCategory);
                    setTimeout(()=>{
                      this.showFileUpload = false;
                    })
                  }
                }
                
              }
            }else{
              if(callFromSubmit){
                this.fvalue = _.cloneDeep(this.fvalue)
                this.$emit('input', this.fvalue)
                this.$emit('updateData', this.fvalue, this.emitCategory, this.emitSubCategory);
                setTimeout(()=>{
                    this.showFileUpload = false;
                }) 
              }else{
                if(this.value && this.value.length>0){
                  this.$emit('input', this.fvalue)
                  this.$emit('updateData', this.fvalue, this.emitCategory, this.emitSubCategory);
                  this.fvalue = [];
                  this.showFileUpload = false;
                }else{
                  this.$emit('input', []);
                  this.fvalue = [];
                  this.$emit('updateData', [], this.emitCategory, this.emitSubCategory);
                  this.showFileUpload = false;
                }
              }
              
            }
        }
    }else{
        if(callFromSubmit){
            let selectedDocs = this.$store.state.selectedDocumentList;
            if(selectedDocs && selectedDocs.length>0 && [48,50,51].indexOf(this.getUserRoleId)<=-1){
                _.forEach(selectedDocs, (item)=>{
                    if(_.has(item, 'path') && item['path'] ){
                        if(_.has(item, 'status') && item['status']){
                            let findobj = _.find(this.fvalue,{path:item['path']});
                            if(!findobj){
                                item['isNew'] = true;
                                this.fvalue.push(item)
                            }
                        }
                        if(!_.has(item, 'status') ){
                            let findobj = _.find(this.fvalue,{path:item['path']});
                            if(!findobj){
                                item['isNew'] = true;
                                item['status'] = true;
                                this.fvalue.push(item)
                            }
                        }
                    
                    }
                })
            }
            this.$store.commit('updateSelectedDocuments',[]);
            if(this.docAcceptType){
              // (mimetype.includes('image/')
              let filterdAcceptList = _.filter(this.fvalue, (item)=>{
                if(_.has(item, 'mimetype') && acceptTypes.includes(item['mimetype']) ){
                  return item;
                }
              })
              if(filterdAcceptList && filterdAcceptList.length == 0 && acceptTypes && toasterMessage ){
                if(submitCall){
                  this.showToster({ message: toasterMessage, isError: true });
                }
                this.fvalue = [];
              }else{
                this.fvalue = _.cloneDeep(filterdAcceptList);
                if(this.efileDocTagIds && this.checkProperty(this.efileDocTagIds, 'length')>0){
                  _.forEach(this.fvalue, (fItem)=>{
                    if(_.has(fItem, 'efileDocTagIds') && this.checkProperty(fItem, 'efileDocTagIds', 'length')>0){
                      _.forEach(this.efileDocTagIds, (tId)=>{
                        if(fItem['efileDocTagIds'].indexOf(tId)<=-1){
                          fItem['efileDocTagIds'].push(tId)
                        }
                      })
                    }else{
                      fItem['efileDocTagIds'] = this.efileDocTagIds
                    }
                  });
                  this.fvalue = _.cloneDeep(this.fvalue);
                }
                if(this.checkMaxLength && this.maxDocLength && this.multiple){
                  if(this.fvalue && this.fvalue.length > parseInt(this.maxDocLength)){
                    let newArr = this.fvalue.slice(0, this.maxDocLength);
                    this.fvalue = _.cloneDeep(newArr);
                    this.$emit('input', this.fvalue)
                    this.$emit('updateData', this.fvalue, this.emitCategory, this.emitSubCategory);
                  }else{
                    this.$emit('input', this.fvalue)
                    this.$emit('updateData', this.fvalue, this.emitCategory, this.emitSubCategory);
                  }
                }else{
                  this.$emit('input', this.fvalue)
                  this.$emit('updateData', this.fvalue, this.emitCategory, this.emitSubCategory);
                }
                setTimeout(()=>{
                    this.fvalue = [];
                    this.showFileUpload = false;
                }) 
              }
            }else{
              if(this.efileDocTagIds && this.checkProperty(this.efileDocTagIds, 'length')>0){
                _.forEach(this.fvalue, (fItem)=>{
                  if(_.has(fItem, 'efileDocTagIds') && this.checkProperty(fItem, 'efileDocTagIds', 'length')>0){
                    _.forEach(this.efileDocTagIds, (tId)=>{
                      if(fItem['efileDocTagIds'].indexOf(tId)<=-1){
                        fItem['efileDocTagIds'].push(tId)
                      }
                    })
                  }else{
                    fItem['efileDocTagIds'] = this.efileDocTagIds
                  }
                });
                this.fvalue = _.cloneDeep(this.fvalue);
              }
              if(this.checkMaxLength && this.maxDocLength && this.multiple){
                if(this.fvalue && this.fvalue.length > parseInt(this.maxDocLength)){
                  let newArr = this.fvalue.slice(0, this.maxDocLength);
                  this.fvalue = _.cloneDeep(newArr);
                  this.$emit('input', this.fvalue)
                  this.$emit('updateData', this.fvalue, this.emitCategory, this.emitSubCategory);
                }else{
                  this.$emit('input', this.fvalue)
                  this.$emit('updateData', this.fvalue, this.emitCategory, this.emitSubCategory);
                }
              }else{
                this.$emit('input', this.fvalue)
                this.$emit('updateData', this.fvalue, this.emitCategory, this.emitSubCategory);
              }
              
              setTimeout(()=>{
                this.fvalue = [];
                this.showFileUpload = false;
              })
            }
            
        }else{
          if(this.value && this.value.length>0){
            if(this.checkMaxLength && this.maxDocLength && this.multiple){
              if(this.fvalue && this.fvalue.length > parseInt(this.maxDocLength)){
                let newArr = this.fvalue.slice(0, this.maxDocLength);
                this.fvalue = _.cloneDeep(newArr);
                this.$emit('input', this.fvalue)
                this.$emit('updateData', this.fvalue, this.emitCategory, this.emitSubCategory);
              }else{
                this.$emit('input', this.fvalue)
                this.$emit('updateData', this.fvalue, this.emitCategory, this.emitSubCategory);
              }
            }else{
              this.$emit('input', this.fvalue)
              this.$emit('updateData', this.fvalue, this.emitCategory, this.emitSubCategory);
            }
            
            this.showFileUpload = false;
          }else{
            this.$emit('input', []);
            this.fvalue = [];
            this.$emit('updateData', [], this.emitCategory, this.emitSubCategory, true);
            this.showFileUpload = false;
          }
            
        }
    }
  },
  emitBlobFiles(docs){
    this.uploadBloBObject(docs)
  },
  upload(model) {
    let self =this;
    let uploadFIlesErrors =[];
    let mapper = model.map(
      (item) =>{
        if(item.name && item.resourceId){
          let mimetype = mime.lookup(item.name);
          if(mimetype){
            item.mimetype =mimetype;
          }
        }
        let  tempitem = {
          resourceId:item.resourceId?item.resourceId:'',
          name: item.name,
          removeFile:item.removeFile ? item.removeFile : false,
          size:item.size ? item.size : null,
          file: item.file ? item.file : null,
          path: item.path ? item.path : "",
          isNew: item.isNew ? item.isNew : false,
          status: item.status === false || item.status === true ? item.status : true,
          mimetype: item.type ? item.type : item.mimetype,
          uploadedBy:item.uploadedBy?item.uploadedBy:self.checkProperty(self.getUserData,'userId')!=''?self.checkProperty(self.getUserData,'userId'):null,
          uploadedByName:item.uploadedByName?item.uploadedByName:self.checkProperty(self.getUserData,'name')!=''?self.checkProperty(self.getUserData,'name'):'',
          uploadedByRoleId:item.uploadedByRoleId?item.uploadedByRoleId:self.getUserRoleId?self.getUserRoleId:null,
          uploadedByRoleName:item.uploadedByRoleName?item.uploadedByRoleName:self.checkProperty(self.getUserData,'loginRoleName'),
          fileUploading: item.path ? false : true,
          efileDocTagIds:this.efileDocTagIds?this.efileDocTagIds:[],
          efileDocSubTagIds:item.efileDocSubTagIds?item.efileDocSubTagIds:[]
        }
        return tempitem;
      }
    );
    if (mapper.length > 0 && this.sendS3Responce) {
        let count =0;
        this.showFileTypeError =""
        mapper.forEach((doc, index) => {
          if (doc.file) {
              self.filesUploading =true;
                if(self.fileAcceptType !=''){
                  if(self.fileAcceptType && self.fileAcceptType =="MSWORD"){
                    if(doc.mimetype == 'application/pdf' || doc.mimetype == 'image/*' ){
                      self.showFileTypeError ="Upload only word format document";
                      mapper.splice(index ,1)
                      self.filesUploading =false;
                      return false;
                    }
                  }
                }
                self.filesUploading =true;
                let formData = new FormData();
                formData.append("files", doc.file);
                formData.append("secureType", "private");
                formData.append("getDetails", true);
                self.$store.dispatch(this.uploadction, formData).then((response) => {
                  if(self.checkProperty(response.data.result,'length')==0){
                    self.filesUploading =false; 
                      // doc['removeFile'] = true;
                      // doc['fileUploading'] = false
                      // mapper[index] = doc;
                   // self.remove(index)

                         doc.isNew = true;
                        doc['file'] =null
                        doc.fileUploading = false
                        delete doc.file;
                        delete doc.url;
                        mapper[index] = doc;
                        if(!self.multiple){
                          self.fvalue =[];
                        }
                          self.fvalue[index] =doc
                          self.fvalue =_.cloneDeep(self.fvalue);
                  }
                    response.data.result.forEach((urlGenerated) => {
                        doc.isNew = true;
                        doc.url = urlGenerated["url"];
                        doc.path = urlGenerated["path"];
                        if(_.has(urlGenerated ,'size' )){
                          doc['size'] = urlGenerated['size'];
                        }
                        doc['extn'] = urlGenerated['extn']
                        doc['file'] =null
                        doc.fileUploading = false
                        delete doc.file;
                        delete doc.url;

                        mapper[index] = doc;
                        if(self.callExtract && self.fieldName == 'capSelectNotice'){
                          // self.extractDocument(urlGenerated)
                        }
                        if(!self.multiple){
                          self.fvalue =[];
                        }
                     //   if(self.checkProperty(doc,'path','length')>1){
                          self.fvalue[index] =doc
                          self.fvalue =_.cloneDeep(self.fvalue);
                     //   }
                         
                      });
                    count =count+1;
                    if(mapper.length >=count ){
                      self.filesUploading =false; 
                      let list = _.filter(self.fvalue, (item)=>{
                          if((!_.has(item, 'removeFile') || item['removeFile'] == false)){
                              return item
                          }
                      })
                      self.fvalue =_.cloneDeep(list);  
                    }
                      if(mapper.length ==count){
                        self.filesUploading =false; 
                      let list = _.filter(self.fvalue, (item)=>{
                          if(self.checkProperty(item,'path','length')>5){
                              return item
                          }
                      })
                      self.fvalue =_.cloneDeep(list);
                      }

                }).catch((error) => {
                  count =count+1;
                  let securedError = '';
                  if (_.has(error, 'error') && _.has(error['error'], 'message') && this.checkProperty(error['error'], 'message')) {
                      securedError = this.checkProperty(error['error'], 'message');
                      uploadFIlesErrors.push(securedError);
                      securedError = '';
                      doc['removeFile'] = true;
                      doc.fileUploading = false
                  }
                  if(mapper.length >=count ){
                      self.filesUploading =false; 
                      let list = _.filter(self.fvalue, (item)=>{
                          if(!_.has(item, 'removeFile') || item['removeFile'] == false ){
                              return item
                          }
                      })
                      self.fvalue =_.cloneDeep(list);
                      //this.updateData();                        
                    }
                    if(mapper.length ==count){
                        self.filesUploading =false; 
                      let list = _.filter(self.fvalue, (item)=>{
                          if(self.checkProperty(item,'path','length')>5){
                              return item
                          }
                      })
                      self.fvalue =_.cloneDeep(list);
                      }
                })
          }else{
              count =count+1;
              if(mapper.length >=count ){
                  self.filesUploading =false; 
                  let list = _.filter(self.fvalue, (item)=>{
                      if(!_.has(item, 'removeFile') || item['removeFile'] == false ){
                          return item
                      }
                  })
                  self.fvalue =_.cloneDeep(list);
              }
              if(mapper.length ==count){
                        self.filesUploading =false; 
                      let list = _.filter(self.fvalue, (item)=>{
                          if(self.checkProperty(item,'path','length')>5){
                              return item
                          }
                      })
                      self.fvalue =_.cloneDeep(list);
                      }
          }
        });
        model.splice(0, mapper.length, ...mapper);
        //this.updateData();
       
    }else if(mapper.length > 0 && !this.sendS3Responce && false){
      this.filesUploading =true;
      let count =0;
      this.showFileTypeError =""
      mapper.forEach((doc, index) => {
        if (doc.file) {
          if(self.fileAcceptType !=''){
              if(self.fileAcceptType && self.fileAcceptType =="MSWORD"){
                  if(doc.mimetype == 'application/pdf' || doc.mimetype == 'image/*' ){
                    self.showFileTypeError ="Upload only word format document";
                      mapper.splice(index ,1)
                      self.filesUploading =false;
                      return false;
                  }
          
              }
          }
          self.filesUploading =true;
          if(!self.multiple){
              self.fvalue =[];
          }
          count =count+1;
          if(mapper.length >=count ){
            self.filesUploading =false;                             
          }
        }else{
          count =count+1;
        }
      });
      model.splice(0, mapper.length, ...mapper);
    }
    self.fvalue =_.cloneDeep(self.fvalue);
  },
  remove(index) {
    this.fvalue[index].status = false;
    let selectedDoc=this.fvalue[index]
    if(this.deleteDocPermenantly){
      this.fvalue.splice(index, 1); 
      this.$emit('input', this.fvalue)
    }
    else{
        this.fvalue.splice(index, 1); 
        this.$emit('input', this.fvalue) 
    }  
    this.removeFileFromS3(selectedDoc)
  },
  updateFormatType(type){
    if(type == 'Form'){
      this.docAcceptType = 'application/pdf'
    }
    if(type == 'Letter'){
      this.docAcceptType = 'application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document'
    }
    if(type == 'Audit Response'){
      this.docAcceptType = 'application/pdf,application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document'
    }
  },
  emitUploadingAction(dta){
    //console.log(JSON.stringify(dta))
  },
},
computed: {
  getLabel(){
    let label = _.cloneDeep(this.label);
    if(this.checkFieldIsRequired({'key':this.tplkey,'section':this.tplsection, 'fieldsArray':this.fieldsArray, 'required':this.required })){
      label = label+"<em>*</em>";
    }
    return label;
  },
  getlist() {
      return  _.filter(this.fvalue, function (item) {
          if(item['status'] == true &&( (_.has(item, 'removeFile') && item['removeFile'] == false) || !_.has(item, 'removeFile'))){
              return item;
          }
      })
  },

  checkFilesUploadCompleted(){
    let list = _.filter(this.fvalue, (item)=>{
      if((!_.has(item, 'removeFile') || item['removeFile'] == false)
            &&(!_.has(item, 'path') || this.checkProperty(item, 'path','length')<5)&& _.has(item, 'fileUploading') )
     {
         return item
       }
    })
   if(this.checkProperty(list, 'length')==0){
      return true
    }
  return false
  }
},
mounted(){
  let url = window.location.origin;
  if(url.includes('immibox')){
    this.windowOpeningUrl = 'https://immibox.com/app'
  }
  if(url.includes('anyclap')){
    this.windowOpeningUrl = 'https://anyclap.com/app'
  }
  this.getRoutePath();
  //this.getGoogleDriveAccessToken();
  if(this.accept && this.accept !=''){
    this.docAcceptType = this.accept;
  }
  if(this.formLetterType){
    if(this.formLetterType == 'Form'){
      this.docAcceptType = 'application/pdf'
    }
    if(this.formLetterType == 'Letter'){
      this.docAcceptType = 'application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document'
    }
  }
  if(this.value){
      this.fvalue = _.cloneDeep(this.value);
  }
  
  this.changeTab('', true)
},
props: {
  maxData:null,
  efileDocTagIds:[],
  fileUploadShowingText:{
    type:String,
    default:'Upload'
  },
  callFromDocuments:{
    type:Boolean,
    default:false
  },
  uploadction:{
    type:String,
    default:'uploadS3File'
  },
  depType:{
    type:String,
    default:''
  },
  depLabel:{
    type:String,
    default:''
  },
  docUserType:{
    type:String,
    default:''
  },
  formLetterType:{
    type:String,
      default:''
  },
  userType:{
      type:String,
      default:''
  },
  typeId:null,
  childrenId:{
      type:String,
      default:''
  },
  userName:{
      type:String,
      default:''
  },
  emitSubCategory:null,
  emitCategory:{
      type:String,
      default:''
  },
  showToBeneficiary:{
    type:Boolean,
    default:false
  },
  sendS3Responce:{
    type:Boolean,
    default:true  // if true this component emit file s3 data , if false then it will emit file object data
  },
  value: null,
  formscope:{
    type: String,
    default: '',
  },
  cid: {
    type: String,
    default: '',
  },
  fieldName: {
    type: String,
    default: null,
  },
  placeHolder: {
    type: String,
    default: null,
  },
  fieldsArray:Array,
  fileAcceptType: {
        type: String,
        default: ''
  },
  tplsection:{
      type: String,
      default: null,
  },
  tplkey:{
      type: String,
      default: null,
  },
  allowCustomPopup:{
    type: Boolean,
    default: true,
  },
  inputId: {
    type: String,
  },
  name: {
    type: String,
    default: 'file-input',
  },
  accept: {
    type: String,
  },
  capture: {
  },
  disabled: {
    default: false,
  },
  multiple: {
    type: Boolean,
    default: false,
  },
  maximum: {
    type: Number,
  },
  addIndex: {
    type: [Boolean, Number],
  },
  directory: {
    type: Boolean,
  },
  createDirectory: {
    type: Boolean,
    default: false
  },
  postAction: {
    type: String,
  },
  putAction: {
    type: String,
  },
  vvas: {
    type: String,
    default: ""
  },
  required: {
    type: Boolean,
    default: false,
  },
  datatype: {
    type: String,
    default: ""
  },
  maxDocLength:null,
  checkMaxLength:{
    type: Boolean,
    default: false,
  }
},
beforeDestroy() {
  this.fvalue = [];
  window.removeEventListener('message', this.receiveMessage);
  // const $ = JQuery;
  // $('body').removeClass('vm--block-scroll');
},
watch:{
  // showFileUpload(val){
  //   // clearInterval(this.checkParentInterval);
  // }
}
}
</script>
<style>

</style>